/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiPanelService } from '../multi-panel.service';
import { MultiPanelItemDirective } from '../multi-panel-item/multi-panel-item.directive';
import { Observable } from 'rxjs';

@Component({
	selector: 'tp-multi-panel-content',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './multi-panel-content.component.html',
	styleUrls: ['./multi-panel-content.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiPanelContentComponent implements OnInit {
	private multiPanelService = inject(MultiPanelService);
	private multiPanelItem = inject(MultiPanelItemDirective);

	protected collapsed$!: Observable<boolean>;

	public ngOnInit() {
		this.collapsed$ = this.multiPanelService.isCollapsed$(this.multiPanelItem.id);
	}
}
